const TRANSLATIONS_EN_OLD = {
  // Footer
  footer: {
    alert: {
      headline: "Ready to get started?",
      description: "Download our tracker and dominate the leaderboards!",
      button: "Download tracker",
      link: "Learn more",
    },
  },
  countdown: {
    endsIn: "ends in",
    hasEnded: "has ended",
    days: {
      plural: "days",
      singular: "day",
    },
    hours: {
      plural: "hours",
      singular: "hour",
    },
    minutes: {
      plural: "minutes",
      singular: "minute",
    },
    seconds: {
      plural: "seconds",
      singular: "second",
    },
  },
  days: {
    0: "Sun",
    1: "Mon",
    2: "Tue",
    3: "Wed",
    4: "Thu",
    5: "Fri",
    6: "Sat",
  },
  product: {
    discount: "Save",
    btn: {
      label: "See the product",
    },
  },
  // Feed
  feed: {
    welcome_msg: "Welcome back, ",
  },
  // Overview archive (overview page banners + filters)| news, challenges, teams, gathers
  overview: {
    teams: {
      create_btn: "Create new team",
      desc: "Come together as a team to achieve great things!",
      headline: {
        mine: "My teams",
        new: "Discover new",
      },
      badges: {
        mine: "Mine",
        new: "Discover new",
      },
    },
    gathers: {
      create_btn: "Create new gather",
      desc: "Gather your friends or find new ones to shake things up!",
      headline: {
        mine: "My gathers",
        new: "Discover new",
      },
      badges: {
        mine: "Mine",
        new: "Discover new",
      },
    },
  },

  // About page
  about: {
    title: "About World of Gamers",
    desc: "      World of Gamers is a global community platform where gamers engage with other gamers as well as well-known brands. We wish to enable gamers to engage with each other through several means. As a platform we provide rich functionality to support the needs of the individual gamer and organizations while offering a unique possibility for our cooperative partners to engage with their intended key audience.",
    subsection1: {
      header: "What we do",
      desc1:
        "World of Gamers (“WOG”) is a gaming community that carries the DNA of more than 15 years of shaping eSport in Denmark and the Nordics.",
      desc2:
        "WOG is a gaming community with regional activities. We are using the gamification of statistics to activate our user and give them the option to create content for the whole community in a easy and accessible manner.",
    },
    subsection2: {
      header: "Who we are",
      desc1:
        "We are a team of passionate gamers who played our role in creating a strong foundation for eSport and raising the bar.",
      desc2:
        "World of Gamers are based on the Nordic model with good values and ethics, and is born out of our passion for gaming and our ambition to create something unique that has the potential to elevate gaming and eSport and set new standards.",
    },
    subheader2: "Who we are",
    subheader3: "The Nordic model",

    list: {
      1: "Bringing people together physically and/or digitally",
      2: "Uniting people based on a healthy and responsible community",
      3: "The ability for all participants to grow and develop their skills",
      4: "Providing safe and good experiences for all participants",
      5: "Uniting participants regardless of age, gender, and social background",
      6: "Contributing to giving participants increased value in their life",
      7: "Good values and ethics by treating fellow participants nicely",
      8: "Promoting happiness and passion through all activities",
    },
  },

  // Not found
  not_found: {
    title: "404 PAGE NOT FOUND",
    desc: "This page either does not exists, or is no longer available.",
    button: "Go back to Wog",
  },

  // help page
  help: {
    title: "Feedback",
    general_issues: {
      title: "General issues",
      desc: "Report issues that appeared during interacting with website:",
      list: {
        0: "using search field",
        1: "create button",
        2: "navigation, etc.",
      },
    },
    sign_up: {
      title: "Sign up process",
      desc: "Report issues on creating an account: ",
      list: {
        0: "performance",
        1: "occuring errors",
        2: "problems connecting through Battle.net or Steam platform, etc.",
      },
    },
    profile: {
      title: "Profile page",
      desc: "Report issues on profile page: ",
      list: {
        0: "connecting games account",
        1: "adding to friends",
        2: "editing profile",
        3: "notifications, etc.",
      },
    },
    create_challenge: {
      title: "Create a challenge",
      desc: "Report issues that appeared while creating a challenge: ",
      list: {
        0: "text formatting",
        1: "setting the dates",
        2: "choosing criterias, etc.",
      },
    },
    single_challenge: {
      title: "Single challenge",
      desc: "Report issues that appeared during interacting with single challenge page:  ",
      list: {
        0: "incorrect leaderboard",
        1: "wrong data",
        2: "participating in a challenge, etc.",
      },
    },
    challenge_overview: {
      title: "Challenges overview",
      desc: "Report issues that appeared during interacting with challenges overview page: ",
      list: {
        0: "incorrect leaderboard",
        1: "wrong data",
        2: "participating in a challenge, etc.",
      },
    },
  },
  // privacy policy
  privacy_policy: {},

  // terms of service
  term_of_service: {},

  // Basic Buttons text. other btn text's will be replaced with these for convenience
  // comments next to it is where where specific ones can be found
  // Words that are all capital should be capitalized in scss, not here.
  buttons: {
    upload: "Upload",
    save: "Save",
    save_changes: "Save changes",
    cancel: "Cancel",
    apply_theme: "Apply", // Theme picker
    remove_avatar: "Remove image", // Profile
    add_friend: "Add friend", // Profile
    unfriend: "Unfriend", // Profile
    manage_btn: "Manage account",
    follow: "Follow",
    unFollow: "Unfollow",
    log_in: "Log in",
    log_out: "Log out", // Navigation
    create: "Create", // Navigation
    see_more: "See more", // Home
    go_back: "Go back", // Home
    join: "Join", // Challenges cards
    get_started: "Get started now",
    try_btn: "Try it out",
    ready: "Ready", // Sign up 2
    connect_accounts: "Connect accounts", // Sign up 3
    explore_challenges: "Explore challenges",
    explore_teams: "Explore teams",
    skip_to_home: "Skip to homepage", // Sign up 3
    remove_btn: "Remove image",
    connect: "Connect",
    connected: "Connected",
    disconnect: "Disconnect",
  },

  // Strings used globaly
  strings: {
    step: "Step", // `Step` x of x
    of: "of", // Step x `of` x

    // Feature names, navigation, carousels etc
    challenges: "Challenges",
    challenge: "challenge", // non uppercase
    teams: "Teams",
    team: "team", // non uppercase
    news: "News",
    gathers: "Gathers",
    gather: "gather", // non uppercase
    feed: "Feed",
    friends: "Friends",
    friend: "friend", // non uppercase
    messages: "Messages",
    zones: "Zones",
    participants: "Participants", // Gathers
    interested: "Interested", // Gathers
    you_havent: "You haven't", // Feed
    user_hasnt: "This user hasn't", // Feed
    shared_anything: "shared anything yet.", // Feed
    share_something_friends: "Share something with your friends...", // Placeholder-inputs
    // Will have another word like "team, challenge, news" etc at the end
    share_something_about: "Share something about this", // Placeholder-inputs
    share_about_yourself: "Share something about yourself", // profile desc placeholder
    userName: "Username",
    fullName: "Full name",
    about: "About",
    uploadAvatar: "Upload avatar",
    user_name: "Username (22 character limit)",
    user_name_placeholder: "Your username",
    full_name: "Full name",
    full_name_placeholder: "Tell us your name",
    about_placeholder: "Tell others a bit about yourself",
    upload_avatar: "Upload avatar",
  },
  logitech: {
    keyWithLink:
      "Hey this is a <1>LINK</1>! Also called <strong>hyperlink</strong>",
    signup: {
      headline: "Welcome to the Logitech McLaren G Challenge Race Days! ",
      description:
        "Set your lap time in Forza Motorsport and compete against the other drivers in your store and region. Check results weekly at www.logitechgchallenge.com/race-days and the Logitech G Discord.",
    },
    input: {
      headline: "Sign up to start",
      email: {
        label: "Email",
        placeholder: "john@doe.com",
      },

      store: {
        label: "Store",
        placeholder: "Enter your store",
      },
      fullName: {
        label: "Name First & Last ",
        placeholder: "John Doe",
      },
      userName: {
        label: "Username",
        placeholder: "Enter your username",
      },
      dateOfBirth: {
        label: "Date of Birth",
        placeholder: "Enter your date of birth",
      },
      terms: {
        headline: "Terms and Conditions",
        label: "I agree to the above",
        description:
          "All participants must read and understand the Terms & Conditions before submitting a contest entry.",
        descriptionWithLink:
          "All participants must read and understand the <1>Terms & Conditions</1> before submitting a contest entry.",
      },
      submit: {
        label: "Sign up",
      },
    },
  },

  elgiganten: {
    input: {
      email: {
        label: "Email",
        placeholder: "john@doe.com",
      },

      firstName: {
        label: "First name ",
        placeholder: "John",
      },

      lastName: {
        label: "Last name",
        placeholder: "John Doe",
      },

      phoneNumber: {
        label: "Phone number",
        placeholder: "+123456789",
      },

      street: {
        label: "Full street name / Address",
      },

      postalCode: {
        label: "Zip code",
      },

      country: {
        label: "Country ",
      },

      city: {
        label: "City",
      },

      stateProvince: {
        label: "State / Province",
        placeholder: "State or Province name",
      },
    },
  },
};

export default TRANSLATIONS_EN_OLD;
